import Api from "./baseApi";

export default {
  listByProduct: productId => Api.get(`/api/competitor-prices/product/${productId}`),
  addLink: (productId, url) => Api.post(`/api/competitor-prices/product/${productId}`, { url }),
  refreshProduct: productId => Api.post(`/api/competitor-prices/product/${productId}/refresh`),
  deleteLink: id => Api.delete(`/api/competitor-prices/${id}`),
  overview: (tenantId, site) => Api.get("/api/competitor-prices/overview", { params: { tenantId, site } }),
  history: (id, days = 30) => Api.get(`/api/competitor-prices/${id}/history`, { params: { days } }),
  status: () => Api.get("/api/competitor-prices/status"),
  refreshAll: () => Api.post("/api/competitor-prices/refresh-all")
};
